import * as React from 'react';
import { PaymentInstructionLayout } from '../../../../component/PaymentInstructionLayout.js';

const Multibanco = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.multibanco.info"
    });
};

export { Multibanco };
//# sourceMappingURL=Multibanco.js.map
